'use strict';

var _ = require('lodash');
var MultiSelectComboboxDirective = function MultiSelectComboboxDirective(MultiSelectComboboxFactory) {
  return {
    restrict: 'E',
    template: require('../templates/multi-select-combobox.html'),
    replace: true,
    // expected value of model is array like ['value1', 'value2'...]
    require: 'ngModel',
    scope: {
      // expected array with next item structure { value: string, dropdownVisibleValue: (string=) }
      comboboxValues: '=',
      placeholder: '@',
      // [true,false*]
      isDisabled: '=?',
      typeAhead: '=?',
      withMessage: '=?',
      onDropdownHidden: '=?',
      minSelection: '=?',
      selectionLimit: '=?',
      dynamicDropdownWidth: '=?',
      listItemHeight: '=?'
    },
    link: function link($scope, elem, attr, ngModelCtrl) {
      var input = elem.find('input');
      var dropdownToggle = elem.find('.dropdown-toggle');
      $scope.isDisabled = $scope.isDisabled || false;
      if (_.isUndefined($scope.typeAhead)) {
        //default value for typeAhead
        $scope.typeAhead = true;
      }
      var values = [];
      var multiSelectCombobox = null;
      var eventHandlers = {
        onDropdownHidden: $scope.onDropdownHidden
      };
      function setSelectedValues(data, comboboxValues) {
        var EMPTY_STRING = '';
        var dataMap = [];
        _.forEach(data, function (element) {
          dataMap[element + EMPTY_STRING] = true;
        });
        _.forEach(comboboxValues, function (curComboValue) {
          curComboValue.selected = false;
          if (_.isArray(data)) {
            curComboValue.selected = curComboValue.selected || !!dataMap[curComboValue.value + EMPTY_STRING];
          } else {
            curComboValue.selected = data && data.toString() === curComboValue.value + EMPTY_STRING;
          }
        });
      }
      function formatComboboxValues(comboboxValues) {
        return _.transform(comboboxValues, function (result, current) {
          if (_.isString(current) || _.isNumber(current)) {
            result.push({
              value: current
            });
          } else {
            result.push(current);
          }
        });
      }
      ngModelCtrl.$render = function () {
        values = formatComboboxValues($scope.comboboxValues);
        setSelectedValues(ngModelCtrl.$viewValue, values);
        if (multiSelectCombobox === null) {
          //if remove $setPristine empty multiselect combobox will be red on creation
          ngModelCtrl.$setPristine();
          //creating combobox should be here due invoking ngModelCtrl.$setViewValue on directive creation
          multiSelectCombobox = new MultiSelectComboboxFactory(elem, values, ngModelCtrl.$setViewValue.bind(ngModelCtrl), eventHandlers, $scope.selectionLimit, $scope.minSelection, $scope.dynamicDropdownWidth, $scope.listItemHeight);
        } else {
          multiSelectCombobox.render(values);
        }
      };
      ngModelCtrl.$formatters.push(function (value) {
        //update widget value on data-model change
        setSelectedValues(value, values);
        return value;
      });
      $scope.$watch('comboboxValues', function (newValue, oldValue) {
        if (oldValue !== newValue && multiSelectCombobox !== null) {
          values = formatComboboxValues(newValue);
          multiSelectCombobox.render(values);
        }
      });
      $scope.$watch('isDisabled', function () {
        if ($scope.isDisabled === true) {
          dropdownToggle.attr('disabled', 'disabled');
          dropdownToggle.addClass('disabled');
          input.attr('disabled', 'disabled');
        } else {
          dropdownToggle.removeAttr('disabled');
          dropdownToggle.removeClass('disabled');
          input.removeAttr('disabled', 'disabled');
        }
      });
      input.on('focus', function () {
        ngModelCtrl.$validate();
        elem.triggerHandler('focus');
      });
    }
  };
};
MultiSelectComboboxDirective.$inject = ['MultiSelectComboboxFactory'];
module.exports = MultiSelectComboboxDirective;